var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticStyle:{"display":"flex"}},_vm._l((_vm.displayModules),function(item){return _c('div',{key:item.name,staticClass:"mx-3",staticStyle:{"cursor":"pointer"},style:({
				'color': item.name==_vm.selectedItem.name? '#2962ff': 'black',
				'text-decoration': item.name==_vm.selectedItem.name? 'none': 'underline'
			})},[_c('p',{on:{"click":function($event){return _vm.changePage(item)}}},[_vm._v(_vm._s(item.name))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }